<template>
  <div>
    <p>admin main</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.dropdown-item {
  cursor: pointer;
}
</style>